// Textos de la pantalla de cobro. Viven aquí, y no en el componente, para que KIO-08 pueda agregar
// otros idiomas sin tocar la lógica.
export const checkoutTexts = {
  paymentWait: {
    title: 'Acerque o inserte su tarjeta en el POS',
    amountLabel: 'Total a pagar',
    posLabel: 'POS',
    timeLeftLabel: 'Tiempo restante',
    secondsUnit: 's',
    // Lo que lee el lector de pantalla cada 10 s; el número visible cambia cada segundo.
    timeLeftAnnouncement: (seconds) => `Quedan ${seconds} segundos para pagar`,
    timeUpAnnouncement: 'Se acabó el tiempo para pagar',
    arrowAlt: 'El POS está en esta dirección',
  },
  // SOK-02: pantalla de cobro fallido. Un título y una instrucción por motivo (utils/paymentFailure.js);
  // si un mensaje no se entiende en el tótem, se cambia aquí. El pedido se conserva en todos los casos.
  paymentFailure: {
    dialogTitle: 'Pago no realizado',
    timeoutDialogTitle: 'Tiempo Agotado',
    reasons: {
      timeout: {
        title: 'Se acabó el tiempo',
        message: 'Se acabó el tiempo en el POS. Toca Reintentar pago y acerca tu tarjeta.',
      },
      // Rechazo y falta de saldo dicen lo mismo a propósito: la pantalla está a la vista de la fila.
      declined: {
        title: 'Tarjeta rechazada',
        message: 'Tu tarjeta fue rechazada. Prueba con otra tarjeta.',
      },
      insufficient_funds: {
        title: 'Tarjeta rechazada',
        message: 'Tu tarjeta fue rechazada. Prueba con otra tarjeta.',
      },
      pin: {
        title: 'PIN incorrecto',
        message: 'El PIN no es correcto. Toca Reintentar pago e ingrésalo de nuevo.',
      },
      card_error: {
        title: 'No pudimos leer tu tarjeta',
        message: 'Toca Reintentar pago y déjala en el POS hasta que termine. Si sigue, prueba con otra tarjeta.',
      },
      communication: {
        title: 'Sin conexión con el POS',
        message: 'No pudimos hablar con el POS. Intenta de nuevo; si sigue, pide ayuda.',
      },
      canceled_by_user: {
        title: 'Pago cancelado',
        message: 'Se canceló el pago en el POS. Toca Reintentar pago para pagar de nuevo.',
      },
      // El único mensaje genérico: solo para lo que no se pudo clasificar.
      unknown: {
        title: 'Lo sentimos',
        message: 'No se pudo completar el pago. Tu pedido sigue guardado: toca Reintentar pago.',
      },
    },
    // KIO-03: el tótem dejó de esperar, pero el cobro puede seguir abierto en el POS.
    expired: {
      title: 'Se acabó el tiempo',
      message: 'Se agotó el tiempo para pagar. Si el POS aún muestra el cobro, cancélalo ahí.',
    },
    outOfStock: {
      title: 'Lo sentimos',
      message: 'El pedido fue cancelado y hay productos sin stock',
    },
    retryButton: 'Reintentar pago',
    processingButton: 'Procesando...',
    newPurchaseButton: 'Nueva compra',
  },
  // SOK-04: sin red no se inicia un cobro; el menú y el carro siguen funcionando.
  connectivity: {
    offlineNotification: 'Sin conexión. Puedes ver el menú; el pago se habilitará cuando vuelva la red.',
    restoredNotification: 'Conexión restablecida. Ya puedes pagar.',
    blockedButton: 'Sin conexión, espera un momento',
    // Puntos 4 y 5: la red se cortó en pleno cobro. Nunca se cobra de nuevo: se confirma el mismo cobro.
    waitingTitle: 'Verificando tu pago…',
    waitingMessage: 'Se cortó la conexión. Apenas vuelva confirmamos tu pago. No vuelvas a pasar la tarjeta.',
    resumingButton: 'Verificando tu pago…',
    unconfirmedDialogTitle: 'Pago sin confirmar',
    unconfirmed: {
      title: 'No pudimos confirmar tu pago',
      message: 'Se cortó la conexión. Si ya pagaste en el POS, no vuelvas a pagar y pide ayuda al personal.',
    },
  },
};
